/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Spec_AgentsInputs */

const en_home_spec_agents = /** @type {(inputs: Home_Spec_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents`)
};

/**
* | output |
* | --- |
* | "Agents" |
*
* @param {Home_Spec_AgentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_spec_agents = /** @type {((inputs?: Home_Spec_AgentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Spec_AgentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_spec_agents(inputs)
});
export { home_spec_agents as "home.spec.agents" }